import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Spin, Card } from 'antd';
import { FilePdfOutlined, EyeOutlined } from '@ant-design/icons';
import { API_BASE_URL } from '../utils/api';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const DocumentThumbnail = ({ 
  documentId, 
  fileName, 
  onView, 
  width = 200,
  height = 250,
  showFileName = true 
}) => {
  const [numPages, setNumPages] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF thumbnail:', error);
    setError(true);
    setLoading(false);
  };

  const fileUrl = `${API_BASE_URL}/documents/${documentId}/file`;

  return (
    <Card
      hoverable
      className="document-thumbnail-card"
      onClick={onView}
      style={{
        width: width,
        height: height + (showFileName ? 60 : 20),
        overflow: 'hidden',
        position: 'relative',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
      }}
      styles={{ body: { padding: 0 } }}
    >
      <div 
        className="thumbnail-preview"
        style={{
          width: '100%',
          height: height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#fafafa',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {loading && (
          <div style={{ textAlign: 'center' }}>
            <Spin />
            <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>Loading preview...</div>
          </div>
        )}

        {error && (
          <div style={{ textAlign: 'center', color: '#999' }}>
            <FilePdfOutlined style={{ fontSize: 48, marginBottom: 8 }} />
            <div style={{ fontSize: 12 }}>Preview unavailable</div>
          </div>
        )}

        {!error && (
          <Document
            file={fileUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            loading=""
            error=""
          >
            <Page
              pageNumber={1}
              width={width - 20}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              loading=""
            />
          </Document>
        )}

        <div 
          className="thumbnail-overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            opacity: 0
          }}
        >
          <div
            style={{
              background: 'rgba(135, 118, 137, 0.9)',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontWeight: 175,
              fontSize: '14px'
            }}
          >
            <EyeOutlined />
            View PDF
          </div>
        </div>
      </div>

      {showFileName && (
        <div
          style={{
            padding: '12px',
            borderTop: '1px solid #f0f0f0',
            background: 'white'
          }}
        >
          <div
            style={{
              fontSize: '13px',
              fontWeight: 175,
              color: '#171717',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            title={fileName}
          >
            {fileName}
          </div>
          {numPages && (
            <div style={{ fontSize: '11px', color: '#999', marginTop: 4 }}>
              {numPages} {numPages === 1 ? 'page' : 'pages'}
            </div>
          )}
        </div>
      )}

      <style>{`
        .document-thumbnail-card:hover .thumbnail-overlay {
          opacity: 1 !important;
        }
        
        .delete-success {
          animation: deleteSuccess 0.5s ease-in-out;
        }
        
        @keyframes deleteSuccess {
          0% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(0.95); }
          100% { opacity: 0; transform: scale(0.9); }
        }
      `}</style>
    </Card>
  );
};

export default DocumentThumbnail;
